module.exports = __webpack_public_path__ + "static/media/indirizzi1.9cdefbd9.png";